module.exports = __webpack_public_path__ + "static/img/noWork.8d1f82fa.png";